export const ADDRESS = "889 Moo3 Mai kao Thalang Chang Wat Phuket 83110, Таиланд";
export const PHONE = "+66 89 290 0110";
export const PHONE_FORMATTED = "+66 (89) 290-01-10";
export const SALES_EMAIL = "sales@villacarte.com";
export const HR_EMAIL = "hr@villacarte.com";
export const OWNER_EMAIL = "vb@villacarte.com";
